import React, { useState, useEffect } from "react";

import { HeartIcon } from "../../assets/icons/HeartIcon";
import { HeartIcon2 } from "../../assets/icons/HeartIcon2";
import WishlistService from "../../services/wishlist";
import "./index.scss";
const WishlistButton = ({ productId, userId }) => {
  const [isInWishlist, setIsInWishlist] = useState(false);
  const [loading, setLoading] = useState(false);

  const wishlistService = new WishlistService();

  useEffect(() => {
    const checkWishlist = async () => {
      try {
        const exists = await wishlistService.isInWishlist(userId, productId);
        setIsInWishlist(exists);
      } catch (error) {
        console.error(error.message);
      }
    };
    checkWishlist();
  }, [userId, productId]);

  const handleToggle = async () => {
    setLoading(true);
    try {
      if (isInWishlist) {
        await wishlistService.removeFromWishlist({ userId, productId });
        setIsInWishlist(false);
      } else {
        await wishlistService.addToWishlist({ userId, productId });
        setIsInWishlist(true);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleToggle}
      disabled={loading}
      className="btn-badget-heart">
      {loading ? "⏳ ..." : isInWishlist ? <HeartIcon2 /> : <HeartIcon />}
    </button>
  );
};

export default WishlistButton;
